
import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer } from "@/api/customer";
import { getSuppliersList } from "@/api/inquiry";
import { queryAllNumberTypes } from "@/api/number-type";
import {
  getPackageInfo,
  updatePackageRemark,
  downloadPackageInfo,
  uploadPackageInfo,
  deletePackageInfo,
} from "@/api/package";

import { getSalesmanList } from "@/api/inquiry";

@Component({
  name: "PackingMaterialManagement",
  components: {
    Pagination,
    EditForm: () => import("./components/edit/index.vue"),
  },
})
export default class extends Vue {
  private isShowMore = false;
  private isShowMore2 = false;
  private listLoading = true;
  private showEdit = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    number: null,
    customerId: null,
    customerAbbr: null,
    nation: null,
    brand: null,
    sellerId: null,
    saleAssistant: null,
  };
  public searchForm = [
    {
      label: "客人简称或编号",
      prop: "customerAbbr",
      key: "customerAbbr",
      type: "input",
      value: "",
      placeholder: "",
      readonly: true,
    },

    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      type: "input",
      options: [],
      value: "",
      placeholder: "销售员",
      readonly: true,
    },
    {
      label: "销售助理",
      prop: "saleAssistant",
      key: "saleAssistant",
      type: "input",
      value: "",
      readonly: true,
    },
    {
      label: "品牌",
      prop: "customerBrand",
      key: "customerBrand",
      type: "input",
      value: "",
      readonly: true,
    },
    {
      label: "号码类型",
      prop: "numberType",
      key: "numberType",
      type: "select",
      value: "",
      options: [],
      resetKey: { label: "name", value: "name" },
      placeholder: "请选择",
    },
    {
      label: "号码",
      prop: "number",
      key: "number",
      type: "input",
      value: "",
      placeholder: "请输入号码",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "",
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "询价参照号",
      prop: "inquiryNumber",
      key: "inquiryNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号类型",
      prop: "inquiryNumberType",
      key: "inquiryNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "客人品牌",
      prop: "brand",
      key: "brand",
      show: true,
      disabled: false,
    },
    {
      label: "类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "包装来源",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "尼龙袋尺寸(CM)",
      prop: "nylonBagLength",
      key: "nylonBagLength",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "产品净重(KG)",
      prop: "productNetWeight",
      key: "productNetWeight",
      show: true,
      disabled: false,
    },
    {
      label: "内盒尺寸(CM)",
      prop: "innerBoxSize",
      key: "innerBoxSize",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "内盒毛重(KG)",
      prop: "innerBoxGrossWeight",
      key: "innerBoxGrossWeight",
      show: true,
      disabled: false,
    },
    {
      label: "外箱尺寸",
      prop: "outerBoxSize",
      key: "outerBoxSize",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "外箱毛重(KG)",
      prop: "outerBoxGrossWeight",
      key: "outerBoxGrossWeight",
      show: true,
      disabled: false,
    },
    {
      label: "装箱数量",
      prop: "cartonQuantity",
      key: "cartonQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "托盘尺寸(CM)",
      prop: "palletSize",
      key: "palletSize",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "托盘毛重(KG)",
      prop: "palletGrossWeight",
      key: "palletGrossWeight",
      show: true,
      disabled: false,
    },
    {
      label: "装托箱数",
      prop: "numberOfCartonsPerPallet",
      key: "numberOfCartonsPerPallet",
      show: true,
      disabled: false,
    },
    {
      label: "装托数量",
      prop: "quantityPerPallet",
      key: "quantityPerPallet",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑",
          code: "",
          click: "handleEdit",
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;
  private customerInfo = {} as any;
  private customerId = "" as any;

  created() {
    this.customerId = this.$route.query.customerId;
    const customerAbbr:any = this.$route.query.customerAbbr;
    const seller:any = this.$route.query.seller;
    const saleAssistant:any = this.$route.query.saleAssistant;
    const customerBrand:any = this.$route.query.customerBrand;
    this.searchForm[0].value = customerAbbr;
    this.searchForm[1].value = seller;
    this.searchForm[2].value = saleAssistant;
    this.searchForm[3].value = customerBrand;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getSalesmanList();
    this.getSuppliersList();
    this.getList();
    this.getNumberTypeList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[5].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private handleExport() {
    //   empty
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
      customerId: this.customerId,
    };
    this.listLoading = false;
    const { total, list }: any = await getPackageInfo(params);
    list.forEach((item) => {
      item.innerBoxSize = this.getSize("innerBox", item);
      item.outerBoxSize = this.getSize("outerBox", item);
      item.palletSize = this.getSize("pallet", item);
    });
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private getSize(key, item) {
    let length = item[`${key}Length`] ? `${item[`${key}Length`]}` : "";
    let width = item[`${key}Width`] ? `${item[`${key}Width`]}` : "";
    let height = item[`${key}Height`] ? `${item[`${key}Height`]}` : "";
    if (!length && !width && !height) {
      return "";
    }
    return `${length}*${width}*${height}`;
  }

  private handleSuccess() {
    this.showEdit = false;
    this.getList();
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await updatePackageRemark(item.id, data);
      this.confirmSuccess();
    } catch (e) {
      await this.getList();
    }
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[1].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  public handleCommand(command) {
    this[command]();
  }

  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showEdit = true;
  }

  // 上传维护
  private async handleUpload(file: any) {
    console.log(file);
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.customerId);
    await uploadPackageInfo(formData);
    this.confirmSuccess();
  }

  public downloadPackageInfo() {
    this.handleDownload(true);
  }

  public downloadPackage() {
    this.handleDownload(false);
  }

  private async handleDownload(allModel) {
    await downloadPackageInfo({
      customerId: this.customerId,
      allModel,
    });
  }

  private async deleteMorePackageInfo() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择要删除的数据");
      return;
    }
    const ids = this.selectedRows.map((item) => item.id);
    const params = ids.map((id) => `ids=${id}`).join("&");
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.deletePackageInfo(params);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async getNumberTypeList() {
    queryAllNumberTypes().then((res) => {
      if (this.searchForm.findIndex((e) => e.label === "号码类型") > -1)
        this.searchForm[
          this.searchForm.findIndex((e) => e.label === "号码类型")
        ].options = res as any;
    });
  }

  //  删除
  public handleDelete(scope) {
    const params = `ids=${scope.row.id}`;
    this.deletePackageInfo(params);
  }

  private async deletePackageInfo(params) {
    await deletePackageInfo(params);
    this.confirmSuccess();
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, time2, ...rest } = params;
    if (time && time.length) {
      rest.piStartTime = time[0];
      rest.piEndTime = time[1];
    }
    if (time2 && time2.length) {
      rest.orderStartTime = time2[0];
      rest.orderEndTime = time2[1];
    }
    delete rest.customerAbbr;
    delete rest.seller;
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleCustomer() {
    // empty
  }

  private linkClick(scope) {
    this.$router.push(`/PIDetails?id=${scope.row.id}`);
  }

  private handleOrderManage(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(`/orderManagement?id=${scope.row.id}&item=${item}`);
  }

  private confirmSuccess() {
    (this.$refs.table as any).$refs.table.clearSelection();
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }
}
